import React from 'react';
import { useOffline } from './useOffline';

export default function OfflineBanner() {
  const { isOffline, wasOffline } = useOffline();

  if (!isOffline && !wasOffline) return null;

  return (
    <div className={`fixed top-0 left-0 w-full h-10 z-[100] flex items-center justify-center transition-transform duration-300 ${isOffline || wasOffline ? 'translate-y-0' : '-translate-y-full'}`}
      style={{ background: isOffline ? 'rgba(245,158,11,0.9)' : 'rgba(34,197,94,0.9)' }}>
      <p className={`text-sm font-semibold ${isOffline ? 'text-black' : 'text-white'}`}>
        {isOffline ? '📡 No connection · Study timer still running · Data saves when back online' : 'Back online ✓'}
      </p>
    </div>
  );
}
